import isNumber from 'lodash-es/isNumber';
import isEmpty from 'lodash-es/isEmpty';
import isBoolean from 'lodash-es/isBoolean';
import isNaN from 'lodash-es/isNaN';

export function getPlansMap(planList = [], key = 'plan_code') {
  if (!planList.length) {
    return null;
  }

  return planList.reduce((pre, item) => {
    const mapKey = item[key];

    return {
      ...pre,
      ...(mapKey ? { [mapKey]: { ...item } } : {}),
    };
  }, {});
}

export const isEmptyVal = (value) => {
  if (value instanceof Date || isBoolean(value)) {
    return false;
  }

  return isNumber(value) ? isNaN(value) : isEmpty(value);
};
